import { number } from 'prop-types';
import React, { useState } from 'react';
import Loader from '../../../components/Loader';
import { useDispatch, useSelector } from 'react-redux';
import { createUpdateBillingInfoAction, updateBillables } from '../../../redux/actions/investigationsActions';
import { TabsSherwood } from '../../components/Tabs';
import BillablesConfiguration from './BillablesConfiguration';
import BillableComboConfiguration from './BillableComboConfiguration';
import ServiceInvestigationConfiguration from './ServiceInvestigationConfiguration';
import TaxRatesConfiguration from './TaxRatesConfiguration';
import EditBillingInfo from './EditBillingInfo';
import { BillItem, BillItemModes, EditBillingProps } from './types';
import { withLocalize } from 'react-localize-redux';


const EditBilling: React.FC<EditBillingProps> = ({ billables, uuidInvestigation, billingInfo, withDiscount, translate, onBillingInfoSuccesfullyUpdated }) => {
    const [tabSelected, setTabSelected] = useState(0);
    const dispatch = useDispatch();
    const investigations = useSelector((state:any) => state.investigations);

    async function callbackUpdateBillingInfo(billingInfo:any){
        await dispatch(
            createUpdateBillingInfoAction(uuidInvestigation, billingInfo)
        );
        onBillingInfoSuccesfullyUpdated(BillItemModes.SHOW);
    }
    async function onBillablesUpdated(){
        // Called after CSV import/save completes
        onBillingInfoSuccesfullyUpdated(BillItemModes.SHOW);
    }
    async function onCombosUpdated(){
        // Called after combo CSV import/save completes
        onBillingInfoSuccesfullyUpdated(BillItemModes.SHOW);
    }

    if(investigations.loading){
        return <Loader />
    }
    if(billingInfo){
        const taxEnabled = billingInfo.params?.taxEnabled === true;
        const labels = [
            translate("hospital.billing.billing_info.title").toString(),
            translate("hospital.billing.billables.title").toString(),
            translate("hospital.billing.combos.title").toString(),
            translate("hospital.billing.services.title").toString(),
            ...(taxEnabled ? [translate("hospital.billing.tax_rates.title").toString()] : []),
        ];
        const children = [
            <EditBillingInfo key="billing-info" billingInfo={{...investigations.currentInvestigation.billingInfo, hospitalName:investigations.currentInvestigation.name}}
                callbackUpdate={callbackUpdateBillingInfo} />,
            <BillablesConfiguration key="billables"
                uuidInvestigation={uuidInvestigation}
                idBillingInfo={billingInfo.id}
                onBillablesUpdated={onBillablesUpdated}
            />,
            <BillableComboConfiguration key="combos"
                uuidInvestigation={uuidInvestigation}
                idBillingInfo={billingInfo.id}
                onCombosUpdated={onCombosUpdated}
            />,
            <ServiceInvestigationConfiguration key="services" uuidInvestigation={uuidInvestigation} />,
            ...(taxEnabled ? [<TaxRatesConfiguration key="tax-rates" uuidInvestigation={uuidInvestigation} />] : []),
        ];
        return (
            <TabsSherwood name="Billing Info" style={{  color: "white" }} whiteBackground={false} tabChangeCallback={(tabSelected) => setTabSelected(tabSelected)}
                initTab = {tabSelected}
                labels={labels} >
                {children}
            </TabsSherwood>
        );
    }
    else{
        return <EditBillingInfo billingInfo={{...investigations.currentInvestigation.billingInfo, hospitalName:investigations.currentInvestigation.name}} 
                callbackUpdate={callbackUpdateBillingInfo}/>
    }
    
};

export default withLocalize(EditBilling);
